import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {khanmigoCoeditingDocumentType} from "./__graphql-types__/index.ts";

export const COEDITING_DOCUMENT_QUERY: GqlOperation<
    khanmigoCoeditingDocumentType["response"],
    khanmigoCoeditingDocumentType["variables"]
> = gqlOp(gql`
    query khanmigoCoeditingDocument($documentId: String!) {
        coeditingDocument(documentID: $documentId) {
            id
            ownerKaid
            threadId
            configName
            title
            persona
            latestSnapshot {
                id
                data
            }
        }
    }
`);
